/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { apiClient } from './client.js';

import type { ReportType } from '@therapy/shared-validators';

export type { ReportType };
export type ReportJobStatus = 'queued' | 'running' | 'succeeded' | 'failed';

export interface ReportJob {
  readonly id: string;
  readonly reportType: ReportType;
  readonly title: string;
  readonly status: ReportJobStatus;
  readonly fileName: string | null;
  readonly error: string | null;
  readonly createdAt: string;
  readonly completedAt: string | null;
}

export interface GenerateReportPayload {
  readonly reportType: ReportType;
  readonly clientId?: string;
  readonly planId?: string;
  readonly dateFrom?: string;
  readonly dateTo?: string;
}

const BASE = '/reports';

export const reportsApi = {
  async list(): Promise<readonly ReportJob[]> {
    const { data } = await apiClient.get<readonly ReportJob[]>(BASE);
    return data;
  },
  async generate(payload: GenerateReportPayload): Promise<ReportJob> {
    const { data } = await apiClient.post<ReportJob>(BASE, payload);
    return data;
  },
  async get(id: string): Promise<ReportJob> {
    const { data } = await apiClient.get<ReportJob>(`${BASE}/${id}`);
    return data;
  },
  async download(id: string): Promise<Blob> {
    const { data } = await apiClient.get<Blob>(`${BASE}/${id}/download`, { responseType: 'blob' });
    return data;
  },
};
